import { Col, Row, Space } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";

export const CheckboxConsent = ({
  isUpiAsba,
  userData,
  setUserData,
  openRead,
  setOpenRead,
}) => {
  const { disclaimerCheck, tncCheck } = userData;
  return (
    <Row justify="space-between" align="top">
      <Col span={24}>
        <Row gutter={[0, { lg: 16 }]}>
          {/* {false && (
            <Col span={20}>
              <Space size="middle">
                <Checkbox
                  checked={disclaimerCheck}
                  onChange={() =>
                    setUserData({
                      ...userData,
                      ...{ disclaimerCheck: !disclaimerCheck },
                    })
                  }
                />
                <label style={{ fontSize: "12px", fontWeight: "normal" }}>
                  <strong>Disclaimer:</strong>
                  According to Regulation 3(d), 3(f) & 3(g) of Insurance
                  Regulatory and Development Authority (IRDA) (Manner of Receipt
                  of Premium) Regulations, 2002, the premium to be paid by any
                  person proposing to take an insurance policy (hereinafter
                  referred to as the proposer) or by the policyholder to an
                  insurer may be made through credit/debit card held in his
                  name, Internet or E-Transfer. As per Anti-Money Laundering /
                  Counter Financing of Terrorism (AML/CFT) guidelines issued by
                  IRDA for general insurance companies are required to carry out
                  Know Your Customer (KYC) norms at the settlement stage where
                  Claim payout /premium refund crosses a threshold of Rs. 1 lakh
                  per claim /premium refund. Company may, at its sole
                  discretion, call for any document before issuance of a policy
                  or for processing the application of Claim payout /premium
                  refund.
                </label>
              </Space>
            </Col>
          )} */}
          {true && (
            <>
              <Col span={24}>
                <Space size="middle">
                  <Checkbox
                    checked={tncCheck}
                    onChange={() =>
                      setUserData({
                        ...userData,
                        ...{ tncCheck: !tncCheck },
                      })
                    }
                  />
                  {!isUpiAsba ? (
                    <label className={"cls_mghuntk5_3c6b3a"}>
                      I hereby agree and confirm of{" "}
                      <label
                        onClick={() => setOpenRead(!openRead)}
                        className={"cls_mghuntk6_04abba"}
                      >
                        T&C's
                      </label>
                    </label>
                  ) : (
                    <label className={"cls_mghuntk6_6af8a7"}>
                      {
                        "I hereby give my consent and authorize my Bank to block the premium amount payable and debit the same from my Account under Bima-ASBA facility on acceptance of my Proposal for Insurance by the Insurer- ManipalCigna Health Insurance."
                      }
                    </label>
                  )}
                </Space>
              </Col>
              {/* <Col span={24} offset={0}>
                            <Space size='middle'>
                                <label style={{ fontSize: '12px', fontWeight: "normal" }}>(only for sum insured upgrade)</label>
                            </Space>
                        </Col> */}
              {openRead && (
                <Col span={24} offset={0}>
                  <div
                    className={"cls_mghuntk6_92615c"}
                  >
                    <p className={"cls_mghuntk6_32242d"}>
                      <strong>Disclaimer:</strong>
                      <br />
                      According to Regulation 3(d), 3(f) & 3(g) of Insurance
                      Regulatory and Development Authority (IRDA) (Manner of
                      Receipt of Premium) Regulations, 2002, the premium to be
                      paid by any person proposing to take an insurance policy
                      (hereinafter referred to as the proposer) or by the
                      policyholder to an insurer may be made through
                      credit/debit card held in his name, Internet or
                      E-Transfer. As per Anti-Money Laundering / Counter
                      Financing of Terrorism (AML/CFT) guidelines issued by IRDA
                      for general insurance companies are required to carry out
                      Know Your Customer (KYC) norms at the settlement stage
                      where Claim payout /premium refund crosses a threshold of
                      Rs. 1 lakh per claim /premium refund. Company may, at its
                      sole discretion, call for any document before issuance of
                      a policy or for processing the application of Claim payout
                      /premium refund.<br />
                      <strong>Terms and Conditions -: </strong>
                      <br />
                      The premium is paid for purchase of insurance policy
                      through net banking account or credit/debit card issued in
                      my name, i.e. proposer/policyholder. Any Document required
                      by the Company before issuance of a policy or for
                      processing application of Claim payout / premium refund
                      shall be provided by me to the Company. Whenever it is
                      sought by the Company.<br />I hereby confirm that all
                      premiums have been/will be paid from genuine sources and
                      no premiums have been/will be paid out of proceeds of
                      crime related to any of the scheduled offences listed in
                      Prevention of Money Laundering Act, 2002. I understand
                      that the Company has the right to call for documents to
                      establish sources of funds. The insurance company has
                      right to cancel the insurance contract in case I am/ have
                      been found guilty by any competent court of law under any
                      of the statutes, directly or indirectly governing the
                      prevention of money laundering in India.
                    </p>
                  </div>
                </Col>
              )}
            </>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default CheckboxConsent;
